import { Upload as AntdUpload, UploadProps as AntdUploadProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";
export type { UploadFile } from "antd";

export interface UploadProps extends AntdUploadProps {}

export const uploadPrefixCls = `${CMP_PREFIX}-upload`;

export const Upload = ({ ...props }: UploadProps) => {
  return <AntdUpload {...props} />;
};
